interface Props {
  onStartFree: () => void;
  onGoPro: () => void;
}

const FREE_FEATURES = [
  "One canvas (lifetime)",
  "All 9 phases — full coaching, no limits within the canvas",
  "Three final documents (DOCX + JSON)",
  "Permanent access to your canvas + documents",
];

const FREE_TRADE = "Data contribution to the anonymized benchmarking pool — structured scores + gap category codes only, no free-text content shared, mandatory for free tier.";

const INDIVIDUAL_FEATURES = [
  "Unlimited canvases",
  "Improvement coaching (per-canvas chat threads)",
  "Revision reminders + ICS calendar invite",
  "On-demand reports — gap summary, scorecard, consistency report, executive one-pager",
  "Document upload accelerator (pre-fill answers from a PDF)",
  "Phase 10 — canvas review and re-versioning",
];

const INDIVIDUAL_PRIVACY = "Private by default — opt in if you want benchmarking insights.";

export function Pricing({ onStartFree, onGoPro }: Props) {
  return (
    <section className="lp-pricing" aria-labelledby="pricing-heading">
      <h2 className="lp-pricing__heading" id="pricing-heading">
        Pick your tier
      </h2>
      <div className="lp-pricing__columns">
        <div className="lp-pricing__col lp-pricing__col--free">
          <div className="lp-pricing__col-tag">FREE TIER</div>
          <div className="lp-pricing__col-price">
            <span className="lp-pricing__price">$0</span>
          </div>
          <ul className="lp-pricing__features">
            {FREE_FEATURES.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
          <p className="lp-pricing__trade">{FREE_TRADE}</p>
          <div className="lp-pricing__col-cta">
            <button className="btn btn--primary btn--large" onClick={onStartFree}>
              Start free →
            </button>
          </div>
        </div>

        <div className="lp-pricing__col lp-pricing__col--paid">
          <div className="lp-pricing__col-tag">PRO · $149/MO</div>
          <div className="lp-pricing__col-price">
            <span className="lp-pricing__price">$149</span>
            <span className="lp-pricing__price-unit">/month</span>
          </div>
          <ul className="lp-pricing__features">
            {INDIVIDUAL_FEATURES.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
          <p className="lp-pricing__trade lp-pricing__trade--paid">{INDIVIDUAL_PRIVACY}</p>
          <div className="lp-pricing__col-cta">
            <button className="btn btn--ghost btn--large" onClick={onGoPro}>
              Go Pro — $149/mo
            </button>
          </div>
        </div>
      </div>
      <p className="lp-pricing__footnote">
        $1,199/yr annual — coming soon.
      </p>
    </section>
  );
}
